import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { GridModalData } from '@app/core/components/grid/modals/grid-modal.service';
import { ModalService } from '@app/core/services/modal.service';
import { OrderheadService, OrderlineCancellationCauseIiem } from '@app/services/orderhead.service';

@GridModalComponent('OrderHeadCancelOrderlinesTs')
@Component({
    selector: 'tt-order-head-cancel-orderlines-dialog',
    templateUrl: './order-head-cancel-orderlines-dialog.component.html',
    styleUrls: ['./order-head-cancel-orderlines-dialog.component.css'],
})
export class OrderHeadCancelOrderlinesDialogComponent {
    public cause = '';

    public note = '';

    public cancellationCauses: OrderlineCancellationCauseIiem[] = [];

    public processing = false;

    constructor(
        public dialogRef: MatDialogRef<OrderHeadCancelOrderlinesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: GridModalData,
        private orderhead: OrderheadService,
        private modal: ModalService,
    ) {
        this.dialogRef.updateSize('min(60rem, 98vw)');
        this.init();
    }

    public async cancelOrderlines() {
        try {
            this.processing = true;
            const { errorcode, errormessage } = await this.orderhead.cancelOrderlines({ orderlines: this.data.selectedRows.map((row) => +row['orderline_keyno']), orderlinecancelcause_keyno: this.cause || '0', cancellation_note: this.note });

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.dialogRef.close(true);
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.processing = false;
        }
    }

    private async loadCancelationCauses() {
        this.cancellationCauses = await this.orderhead.getOrderlineCancellationCauses();
    }

    private async init() {
        this.loadCancelationCauses();
    }
}
